const normalizePathname = (pathname = ''): string => {
  if (!pathname) {
    return '';
  }

  if (pathname === '/') {
    return pathname;
  }

  return pathname.replace(/\/+$/, '');
};

export const PUBLIC_PATHS = [
  '/user/login',
  '/user/register',
  '/user/register-result',
  '/user/forgot-password',
  '/user/change-password',
  '/callback',
  '/public/join',
] as const;

export const PUBLIC_API_PREFIXES = ['/bff/public/'] as const;

export const isPublicPath = (pathname = ''): boolean => {
  const normalizedPathname = normalizePathname(pathname);
  return PUBLIC_PATHS.some((publicPath) => publicPath === normalizedPathname);
};

export const isPublicApiPath = (pathname = ''): boolean => {
  const normalizedPathname = normalizePathname(pathname);
  return PUBLIC_API_PREFIXES.some((prefix) =>
    normalizedPathname.startsWith(prefix),
  );
};
